(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aff-email-url"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aff-email-url')) {
    class AffEmailUrl extends HTMLElement {
      connectedCallback() {
        const email = new URLSearchParams(location.search).get('email');
        const alvo = this.querySelector('[data-aff-email]');
        if (email && alvo) { alvo.textContent = email; this.classList.add('aff-email-url--tem'); }
      }
    }
    customElements.define('aff-email-url', AffEmailUrl);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aff-filtro-pilulas"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aff-filtro-pilulas')) {
    class AffFiltroPilulas extends HTMLElement {
      connectedCallback() {
        this.pilulas = [...this.querySelectorAll('[data-aff-filtro]')];
        this.pilulas.forEach(p => p.addEventListener('click', () => this.aplica(p.dataset.affFiltro, true)));
        const inicial = (location.hash || '').replace('#', '');
        this.aplica(this.pilulas.some(p => p.dataset.affFiltro === inicial) ? inicial : (this.pilulas[0] ? this.pilulas[0].dataset.affFiltro : 'todas'), false);
        // só refiltra quando entram cards novos (rolagem infinita, troca de ordenação); ignora o resto
        this.mo = new MutationObserver((ms) => {
          const novos = ms.some(m => [...m.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[data-aff-modelo]') || n.querySelector?.('[data-aff-modelo]'))));
          if (novos) { clearTimeout(this._t); this._t = setTimeout(() => this.filtra(), 60); }
        });
        this.mo.observe(document.body, { childList: true, subtree: true });
      }
      disconnectedCallback() { this.mo && this.mo.disconnect(); }
      escopo() {
        const sec = this.closest('.shopify-section');
        if (sec && sec.querySelector('[data-aff-modelo]')) return sec;
        let prox = sec && sec.nextElementSibling;
        while (prox && !prox.querySelector('[data-aff-modelo]')) prox = prox.nextElementSibling;
        return prox || document;
      }
      aplica(filtro, gravaUrl) {
        this.atual = filtro;
        this.pilulas.forEach(p => { const on = p.dataset.affFiltro === filtro; p.classList.toggle('aff-filtro__pilula--ativa', on); p.setAttribute('aria-pressed', String(on)); });
        if (gravaUrl) history.replaceState(null, '', filtro === 'todas' ? location.pathname + location.search : '#' + filtro);
        this.filtra();
      }
      combina(card) {
        if (card.dataset.affFamilia !== undefined) {
          const tem = (card.dataset.affModelos || '').split(',').filter(Boolean);
          const alvo = { 'com-datas': 'com datas', 'sem-datas': 'sem datas', 'slim': 'slim' }[this.atual];
          const bloco = card.closest('aff-produtos');
          if (!alvo) { const p = card.dataset.affPadrao; if (p && bloco && bloco.troca) bloco.troca(card, p); return true; }
          if (!tem.includes(alvo)) return false;
          if (bloco && bloco.troca) bloco.troca(card, alvo);
          return true;
        }
        const modelo = card.dataset.affModelo || '', slim = card.dataset.affSlim === '1';
        switch (this.atual) {
          case 'com-datas': return modelo === 'com datas' && !slim;
          case 'sem-datas': return modelo === 'sem datas' && !slim;
          case 'slim': return slim;
          default: return true;
        }
      }
      filtra() {
        if (this._rodando) return; this._rodando = true;
        let visiveis = 0;
        this.escopo().querySelectorAll('[data-aff-modelo]').forEach(card => {
          const item = card.closest('.product-grid__item') || card;
          const ok = this.combina(card);
          item.classList.toggle('aff-filtro-oculto', !ok);
          if (ok) visiveis++;
        });
        const vazio = this.querySelector('[data-aff-vazio]'); if (vazio) vazio.hidden = visiveis > 0;
        if (visiveis !== this._ultimo) { this._ultimo = visiveis; this.escopo().querySelectorAll('aff-produtos').forEach(p => p.monta && p.monta()); }
        this._rodando = false;
      }
    }
    customElements.define('aff-filtro-pilulas', AffFiltroPilulas);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aff-guias"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aff-guias')) {
    class AffGuias extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const aba = e.target.closest('[data-aff-aba]'); if (!aba) return;
          const n = aba.dataset.affAba;
          this.querySelectorAll('[data-aff-aba]').forEach(b => { const on = b === aba; b.classList.toggle('aff-guias__aba--ativa', on); b.setAttribute('aria-selected', String(on)); });
          this.querySelectorAll('[data-aff-painel]').forEach(p => p.classList.toggle('aff-guias__painel--ativo', p.dataset.affPainel === n));
        });
      }
    }
    customElements.define('aff-guias', AffGuias);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aff-lote-modelo"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    document.querySelectorAll('.aff-lote-modelo__info[open], .aff-pre-venda__info[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aff-pill-lote"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aff-pill-lote')) {
    class AffPillLote extends HTMLElement {
      connectedCallback() {
        const alvo = document.querySelector('.aff-lote-modelo');
        const liga = (on) => this.classList.toggle('aff-pill--on', on);
        if (alvo && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver((es) => { const e = es[0]; liga(!e.isIntersecting && e.boundingClientRect.top < 0); }, { threshold: 0 });
          this.io.observe(alvo);
        } else {
          this.onScroll = () => liga(window.scrollY > 400);
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
        this.addEventListener('click', () => alvo && alvo.scrollIntoView({ behavior: 'smooth', block: 'center' }));
      }
      disconnectedCallback() { this.io && this.io.disconnect(); this.onScroll && window.removeEventListener('scroll', this.onScroll); }
    }
    customElements.define('aff-pill-lote', AffPillLote);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aff-preco"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aff-preco')) {
    class AffPreco extends HTMLElement {
      static get observedAttributes() { return ['data-preco']; }
      connectedCallback() { this.render(); }
      attributeChangedCallback() { this.render(); }
      brl(v) { return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
      parcela(n, preco, semJuros, juros) {
        if (n <= semJuros || !juros) return preco / n;
        return preco * juros / (1 - Math.pow(1 + juros, -n));
      }
      render() {
        const preco = Number(this.dataset.preco || 0) / 100;
        const semJuros = Number(this.dataset.semJuros || 1);
        const max = Number(this.dataset.max || semJuros);
        const juros = Number(this.dataset.juros || 0);
        const principal = this.querySelector('[data-aff-principal]');
        const secundaria = this.querySelector('[data-aff-secundaria]');
        const tabela = this.querySelector('[data-aff-tabela]');
        const toggle = this.querySelector('[data-aff-toggle]');
        if (!principal || !preco) return;
        principal.textContent = semJuros + 'x de ' + this.brl(this.parcela(semJuros, preco, semJuros, juros));
        if (secundaria) secundaria.textContent = 'ou em até ' + max + 'x de ' + this.brl(this.parcela(max, preco, semJuros, juros));
        if (tabela) {
          let html = '';
          for (let n = 1; n <= max; n++) {
            const v = this.parcela(n, preco, semJuros, juros);
            html += '<div class="aff-preco__row"><span class="aff-preco__n">' + n + 'x</span><span>de ' + this.brl(v) + '</span>'
              + (n <= semJuros ? '<span class="aff-preco__tag">sem juros</span>' : '')
              + '<span class="aff-preco__total">' + this.brl(v * n) + '<small>total</small></span></div>';
          }
          tabela.innerHTML = html;
        }
        if (toggle && !toggle.dataset.ligado) {
          toggle.dataset.ligado = '1';
          toggle.addEventListener('click', () => {
            const aberta = tabela.classList.toggle('aff-preco__tabela--aberta');
            tabela.setAttribute('aria-hidden', String(!aberta));
            toggle.setAttribute('aria-expanded', String(aberta));
            toggle.textContent = aberta ? 'ocultar parcelamento' : 'ver parcelamento';
          });
        }
      }
    }
    customElements.define('aff-preco', AffPreco);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aff-previa"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aff-previa')) {
    const esc = (t) => t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const inline = (t) => esc(t)
      .replace(/\^\^(.+?)\^\^/g, '<span class="aff-l-versalete">$1</span>')
      .replace(/(^|[\s(“"—])_(.+?)_(?=$|[\s.,;:!?)”"—…])/g, '$1<em>$2</em>')
      .replace(/\[(\d+)\]/g, '<sup><button type="button" data-aff-ref="$1" aria-label="Nota $1">$1</button></sup>');
    function monta(fonte) {
      const notas = {}; const html = [];
      const blocos = fonte.replace(/\r/g, '').split(/\n\s*\n/);
      for (let b of blocos) {
        b = b.trim(); if (!b) continue;
        const ls = b.split('\n');
        if (ls.every((l) => /^\[\d+\]:/.test(l.trim()))) { ls.forEach((l) => { const m = l.trim().match(/^\[(\d+)\]:\s*(.*)$/); notas[m[1]] = m[2]; }); continue; }
        if (/^\*\s*\*\s*\*$/.test(b)) { html.push('<p class="aff-l-ornamento" aria-hidden="true">✷</p>'); continue; }
        if (b.startsWith('## ')) { html.push(`<h3 class="aff-l-capitulo">${inline(b.slice(3))}</h3>`); continue; }
        if (b.startsWith('# ')) { html.push(`<h2 class="aff-l-parte">${inline(b.slice(2))}</h2>`); continue; }
        if (ls.every((l) => l.startsWith('>'))) {
          const txt = ls.map((l) => l.replace(/^>\s?/, '')).join(' ');
          const ultimo = html[html.length - 1];
          if (ultimo && ultimo.startsWith('<div class="aff-l-dedicatoria">')) html[html.length - 1] = ultimo.replace(/<\/div>$/, `<p>${inline(txt)}</p></div>`);
          else html.push(`<div class="aff-l-dedicatoria"><p>${inline(txt)}</p></div>`);
          continue;
        }
        html.push(`<p>${inline(ls.join(' '))}</p>`);
      }
      return { html: html.join(''), notas };
    }
    class AffPrevia extends HTMLElement {
      connectedCallback() {
        this.dlg = this.querySelector('[data-aff-leitor]'); if (!this.dlg) return;
        this.rol = this.querySelector('[data-aff-rolagem]'); this.art = this.querySelector('[data-aff-artigo]');
        this.chave = 'aff-previa:' + this.dataset.livro;
        this.prefs = this.le('aff-previa:prefs') || { tam: 19, tema: 'claro', fonte: 'serifa' };
        this.querySelector('[data-aff-abrir]').addEventListener('click', () => this.abre());
        this.dlg.addEventListener('click', (e) => this.clique(e));
        this.dlg.addEventListener('close', () => this.aoFechar());
        this.dlg.addEventListener('cancel', (e) => { e.preventDefault(); this.fecha(); });
        let ultimo = 0; let t;
        this.rol.addEventListener('scroll', () => {
          const max = this.rol.scrollHeight - this.rol.clientHeight; const y = this.rol.scrollTop; const pct = max > 0 ? y / max : 0;
          this.querySelector('[data-aff-progresso]').style.width = (pct * 100).toFixed(1) + '%';
          this.dlg.classList.toggle('aff-leitor--imerso', y > 120 && y > ultimo && this.querySelector('[data-aff-painel]').hidden);
          ultimo = y; clearTimeout(t); t = setTimeout(() => this.grava(this.chave, { pos: pct }), 250);
          if (y > 40 && !this._restaurando) this.aviso(false);
        }, { passive: true });
        if (/^#previa/.test(location.hash) || new URLSearchParams(location.search).has('previa')) setTimeout(() => this.abre(), 400);
      }
      le(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
      grava(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
      montaTexto() {
        if (this.montado) return; this.montado = true;
        const r = monta(this.querySelector('[data-aff-texto]').textContent);
        this.art.innerHTML = r.html; this.notas = r.notas;
        this.hifeniza();
      }
      // Hifenização em português com padrões (hyphen/pt): insere hífens invisíveis (&shy;) no texto,
      // então a quebra funciona igual em qualquer navegador, sem depender do dicionário do aparelho.
      async hifeniza() {
        try {
          const mod = await import('https://cdn.jsdelivr.net/npm/hyphen@1.14.1/pt/+esm');
          const h = (mod.default || mod);
          this.hif = (html) => h.hyphenateHTMLSync(html, { minWordLength: 5 });
          const pos = this.rol.scrollTop / Math.max(1, this.rol.scrollHeight);
          this.art.innerHTML = this.hif(this.art.innerHTML);
          this.art.classList.add('aff-l-hifenizado');
          if (pos > 0) this.rol.scrollTop = pos * this.rol.scrollHeight;
        } catch (e) { /* sem a biblioteca, fica a hifenização nativa do navegador */ }
      }
      aplica() {
        const p = this.prefs; p.tam = Math.min(26, Math.max(15, p.tam));
        this.dlg.style.setProperty('--tam', p.tam + 'px');
        this.dlg.classList.toggle('aff-leitor--sepia', p.tema === 'sepia'); this.dlg.classList.toggle('aff-leitor--escuro', p.tema === 'escuro');
        this.dlg.classList.toggle('aff-leitor--sans', p.fonte === 'sans');
        this.dlg.querySelectorAll('[data-aff-tema]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.affTema === p.tema)));
        this.dlg.querySelectorAll('[data-aff-fonte]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.affFonte === p.fonte)));
        this.grava('aff-previa:prefs', p);
      }
      abre() {
        this.montaTexto(); this.aplica();
        document.documentElement.classList.add('aff-leitor-aberto');
        this.dlg.showModal();
        if (location.hash !== '#previa') history.replaceState(null, '', location.pathname + location.search + '#previa');
        const salvo = this.le(this.chave);
        setTimeout(() => {
          const max = this.rol.scrollHeight - this.rol.clientHeight;
          if (salvo && salvo.pos > 0.03 && salvo.pos < 0.97) { this._restaurando = true; this.rol.scrollTop = salvo.pos * max; this.aviso(true); setTimeout(() => { this._restaurando = false; }, 600); }
          else this.rol.scrollTop = 0;
        }, 30);
      }
      fecha() { this.dlg.close(); this.aoFechar(); }
      aoFechar() {
        document.documentElement.classList.remove('aff-leitor-aberto'); this.nota(null); this.painel(false); this.aviso(false);
        if (location.hash === '#previa') history.replaceState(null, '', location.pathname + location.search);
      }
      aviso(on) { const a = this.querySelector('[data-aff-aviso]'); if (a) a.hidden = !on; if (on) { clearTimeout(this._av); this._av = setTimeout(() => this.aviso(false), 6000); } }
      painel(on) { const p = this.querySelector('[data-aff-painel]'); p.hidden = !on; this.querySelector('[data-aff-ajustes]').setAttribute('aria-expanded', String(on)); if (on) this.dlg.classList.remove('aff-leitor--imerso'); }
      nota(n) {
        const box = this.querySelector('[data-aff-nota]');
        if (!n) { box.hidden = true; return; }
        this.querySelector('[data-aff-nota-num]').textContent = 'Nota ' + n;
        const html = inline(this.notas[n] || '');
        this.querySelector('[data-aff-nota-texto]').innerHTML = this.hif ? this.hif(html) : html;
        box.hidden = false;
      }
      clique(e) {
        const q = (s) => e.target.closest(s);
        if (q('[data-aff-fechar]')) return this.fecha();
        if (q('[data-aff-ajustes]')) return this.painel(this.querySelector('[data-aff-painel]').hidden);
        const tam = q('[data-aff-tam]'); if (tam) { const antes = this.rol.scrollTop / Math.max(1, this.rol.scrollHeight); this.prefs.tam += Number(tam.dataset.affTam); this.aplica(); this.rol.scrollTop = antes * this.rol.scrollHeight; return; }
        const tema = q('[data-aff-tema]'); if (tema) { this.prefs.tema = tema.dataset.affTema; return this.aplica(); }
        const fonte = q('[data-aff-fonte]'); if (fonte) { this.prefs.fonte = fonte.dataset.affFonte; return this.aplica(); }
        const ref = q('[data-aff-ref]'); if (ref) return this.nota(ref.dataset.affRef);
        if (q('[data-aff-nota-fechar]')) return this.nota(null);
        if (q('[data-aff-inicio]')) { this.aviso(false); this._restaurando = true; this.rol.scrollTop = 0; setTimeout(() => { this._restaurando = false; }, 300); return; }
        if (q('[data-aff-comprar]')) return this.compra(q('[data-aff-comprar]'));
        if (!q('[data-aff-painel]') && !q('[data-aff-nota]')) { this.painel(false); this.nota(null); }
      }
      async compra(botao) {
        if (botao.disabled) return; botao.disabled = true;
        const rot = botao.querySelector('[data-aff-comprar-rotulo]'); const original = rot.textContent; rot.textContent = 'Adicionando…';
        try {
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          const id = this.dataset.variante;
          const secoes = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
          const deferido = CartLinesUpdateEvent.createPromise();
          document.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }], promise: deferido.promise }));
          const r = await fetch(Theme.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: secoes.join(',') }) });
          const resp = await r.json(); if (resp.status) throw new Error(resp.description || 'erro');
          const carrinho = await fetch(`${Theme.routes.cart_url}.js`).then((x) => x.json());
          this.fecha();
          deferido.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrinho), detail: { items: carrinho.items, source: 'aff-previa', sourceId: 'aff-previa', itemCount: 1, sections: resp.sections, didError: false } });
        } catch (err) { rot.textContent = 'Tente de novo'; botao.disabled = false; return; }
        rot.textContent = original; botao.disabled = false;
      }
    }
    customElements.define('aff-previa', AffPrevia);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aff-produtos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aff-produtos')) {
    class AffProdutos extends HTMLElement {
      connectedCallback() {
        this.trilho = this.querySelector('[data-aff-trilho]');
        // famílias (com datas / sem datas / slim num card só): pílulas trocam o miolo do card
        this.addEventListener('click', (e) => { const b = e.target.closest('[data-aff-troca]'); if (b) { e.preventDefault(); this.troca(b.closest('.aff-prod__card'), b.dataset.affTroca); } });
        this.controles = this.querySelector('[data-aff-controles]');
        this.bolinhas = this.querySelector('[data-aff-bolinhas]');
        this.contador = this.querySelector('[data-aff-contador]');
        this.querySelector('[data-aff-anterior]').addEventListener('click', () => this.vai(-1));
        this.querySelector('[data-aff-proximo]').addEventListener('click', () => this.vai(1));
        this.trilho.addEventListener('scroll', () => this.atualiza(), { passive: true });
        // arrastar com o mouse (no dedo o navegador já desliza sozinho)
        let x0 = 0, s0 = 0, moveu = false;
        this.trilho.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || !this.ehCarrossel()) return;
          x0 = e.clientX; s0 = this.trilho.scrollLeft; moveu = false;
          this.trilho.setPointerCapture(e.pointerId);
          this.trilho.classList.add('aff-prod__trilho--arrastando');
        });
        this.trilho.addEventListener('pointermove', (e) => {
          if (!this.trilho.classList.contains('aff-prod__trilho--arrastando')) return;
          const dx = e.clientX - x0; if (Math.abs(dx) > 4) moveu = true;
          this.trilho.scrollLeft = s0 - dx;
        });
        const solta = (e) => {
          if (!this.trilho.classList.contains('aff-prod__trilho--arrastando')) return;
          this.trilho.classList.remove('aff-prod__trilho--arrastando');
          const i = Math.round(this.trilho.scrollLeft / this.trilho.clientWidth);
          this.trilho.scrollTo({ left: i * this.trilho.clientWidth, behavior: 'smooth' });
          if (moveu) { const bloqueia = (ev) => { ev.preventDefault(); ev.stopPropagation(); }; this.trilho.addEventListener('click', bloqueia, { capture: true, once: true }); setTimeout(() => this.trilho.removeEventListener('click', bloqueia, { capture: true }), 50); }
        };
        this.trilho.addEventListener('pointerup', solta);
        this.trilho.addEventListener('pointercancel', solta);
        this.trilho.addEventListener('pointerleave', solta);
        this.ro = new ResizeObserver(() => this.monta());
        this.ro.observe(this.trilho);
        this.monta();
      }
      troca(card, modelo) {
        if (!card || card.dataset.affModelo === modelo) return true;
        const t = card.querySelector(`template[data-aff-modelo="${modelo}"]`); const link = card.querySelector('.aff-prod__link');
        if (!t || !link) return false;
        link.innerHTML = t.innerHTML; link.href = t.dataset.affUrl;
        card.dataset.affModelo = modelo; card.dataset.affSlim = modelo === 'slim' ? '1' : '0';
        card.querySelectorAll('[data-aff-troca]').forEach((b) => { const on = b.dataset.affTroca === modelo; b.classList.toggle('aff-prod__modelo--ativo', on); b.setAttribute('aria-pressed', String(on)); });
        return true;
      }
      disconnectedCallback() { this.ro && this.ro.disconnect(); }
      ehCarrossel() { return getComputedStyle(this.trilho).overflowX === 'auto' && this.trilho.scrollWidth > this.trilho.clientWidth + 2; }
      paginas() { return Math.max(1, Math.round(this.trilho.scrollWidth / this.trilho.clientWidth)); }
      monta() {
        if (!this.ehCarrossel()) { this.controles.hidden = true; return; }
        this.controles.hidden = false;
        const n = this.paginas();
        this.bolinhas.innerHTML = '';
        for (let i = 0; i < n; i++) {
          const b = document.createElement('button'); b.type = 'button'; b.className = 'aff-prod__bolinha'; b.setAttribute('aria-label', 'Página ' + (i + 1));
          b.addEventListener('click', () => this.trilho.scrollTo({ left: i * this.trilho.clientWidth, behavior: 'smooth' }));
          this.bolinhas.appendChild(b);
        }
        this.atualiza();
      }
      atual() { return Math.round(this.trilho.scrollLeft / this.trilho.clientWidth); }
      atualiza() {
        const i = this.atual(), n = this.paginas();
        this.bolinhas.querySelectorAll('.aff-prod__bolinha').forEach((b, k) => b.classList.toggle('aff-prod__bolinha--ativa', k === i));
        if (this.contador) this.contador.textContent = (i + 1) + '/' + n;
        const ant = this.querySelector('[data-aff-anterior]'), prox = this.querySelector('[data-aff-proximo]');
        if (ant) ant.disabled = i <= 0;
        if (prox) prox.disabled = i >= n - 1;
      }
      vai(d) { const i = Math.min(Math.max(this.atual() + d, 0), this.paginas() - 1); this.trilho.scrollTo({ left: i * this.trilho.clientWidth, behavior: 'smooth' }); }
    }
    customElements.define('aff-produtos', AffProdutos);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aff-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aff-video')) {
    class AffVideo extends HTMLElement {
      connectedCallback() {
        this.quadro = this.querySelector('[data-aff-quadro]');
        this.mq = window.matchMedia('(min-width: 750px)');
        this.troca = () => this.monta();
        this.mq.addEventListener ? this.mq.addEventListener('change', this.troca) : this.mq.addListener(this.troca);

        // proporção já antes do vídeo entrar, para a página não pular
        this.ajustaProporcao();

        // só coloca o vídeo na página quando ele se aproxima da tela
        if ('IntersectionObserver' in window) {
          this.ioMonta = new IntersectionObserver((es) => { if (es.some(e => e.isIntersecting)) { this.monta(); this.ioMonta.disconnect(); } }, { rootMargin: '300px 0px' });
          this.ioMonta.observe(this);
        } else { this.monta(); }
      }
      aparelho() { return this.mq.matches ? 'desktop' : 'mobile'; }
      template() { return this.querySelector(`template[data-aff-para="${this.aparelho()}"]`) || this.querySelector('template'); }
      ajustaProporcao() {
        const t = this.template(); if (!t) return;
        const p = parseFloat(t.dataset.affProporcao) || 1.777;
        this.style.setProperty('--aff-video-proporcao', String(p));
      }
      monta() {
        const t = this.template(); if (!t || !this.quadro) return;
        if (this.quadro.dataset.affAtual === this.aparelho()) return;
        this.ajustaProporcao();
        this.quadro.innerHTML = '';
        this.quadro.appendChild(t.content.cloneNode(true));
        this.quadro.dataset.affAtual = this.aparelho();
        const v = this.quadro.querySelector('video');
        if (v && v.hasAttribute('autoplay')) { v.muted = true; v.removeAttribute('controls'); const p = v.play(); p && p.catch && p.catch(() => {}); }
      }
      disconnectedCallback() {
        this.ioMonta && this.ioMonta.disconnect();
        this.mq.removeEventListener ? this.mq.removeEventListener('change', this.troca) : this.mq.removeListener(this.troca);
      }
    }
    customElements.define('aff-video', AffVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
